export default `
fragment FollowedUserFragment on followed_users {
  userId: user_id
  followedUserId: followed_user_id
}
`;
